import React from 'react';
import { LandUseChange, LandUseChangeRow } from '../../../../../../services/types/Calculator';
import { calculateLandUseChange } from '../../Utils/moduleCalculates';
import LandUseChangeBase from './LandUseChangeBase';

interface Props {
  landUseChange: LandUseChange;
  onUpdateLandUseChange: (updatedLandUseChange: LandUseChange) => void;
}

const LandUseChangeSection: React.FC<Props> = ({ landUseChange, onUpdateLandUseChange }) => {
  const calculateSubtotal = (rows: LandUseChangeRow[]) => {
    const totalCarbonSum = rows.reduce((sum, row) => sum + row.totalCarbon, 0);
    return totalCarbonSum * (44 / 12);
  };

  return (
    <LandUseChangeBase
      landUseChange={landUseChange}
      onUpdateLandUseChange={onUpdateLandUseChange}
      calculateFunction={calculateLandUseChange}
      calculateSubtotal={calculateSubtotal}
    />
  );
};

export default LandUseChangeSection;
